import React, { useReducer } from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Button, Collapse, List, ListItem, ListSubheader, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { NavLink as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import { useSidebarQuery } from '@/apis/service/common';
import { useTranslation } from 'react-i18next';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { MenuTile, MenuWrapper, SubMenuWrapper, TextTile } from './style';
import { SidebarIcon } from './SidebarIcon';
import { fontSize } from '@mui/system';
// necessary hard code
interface DropDownState {
  name: string | number;
  value: boolean;
}

function SidebarMenu() {
  const { closeSidebar, isCollapsed } = useContext(SidebarContext);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data } = useSidebarQuery();
  const location = useLocation();
  const [isSelected, setIsSelected] = React.useState<Array<DropDownState>>([]);

  const isMenuActive = (path: string): boolean => {
    return location.pathname === path;
  };

  const isParentMenuActive = (children: any[]): boolean => {
    return children.some((child: any) => location.pathname === child.path);
  };

  const navs = React.useMemo(
    () => [
      {
        key: 1,
        label: `${t('sidebar.agent.title')}`,
        icon: (
          <SidebarIcon.AgentManagement
            color={
              isParentMenuActive([
                { path: '/agents/tree-view' },
                { path: '/agents/list' },
                { path: '/agents/point-transactions' },
                { path: '/agents/permission-settings' },
                { path: '/agents/login-history' },
              ])
                ? '#FFFFFF'
                : '#9DA4AE'
            }
          />
        ),
        children: [
          {
            key: 1.1,
            label: `${t('sidebar.agent.tree')}`,
            path: '/agents/tree-view',
          },
          {
            key: 1.2,
            label: `${t('sidebar.agent.list')}`,
            path: '/agents/list',
          },
          {
            key: 1.3,
            label: `${t('sidebar.agent.point')}`,
            path: '/agents/point-transactions',
          },
          {
            key: 1.4,
            label: `${t('sidebar.agent.permission')}`,
            path: '/agents/permission-settings',
          },
          {
            key: 1.5,
            label: `${t('sidebar.agent.agentLoginHistory')}`,
            path: '/agents/login-history',
          },
        ],
      },
      {
        key: 2,
        label: `${t('sidebar.transactions')}`,
        icon: <SidebarIcon.GameHistory color={isMenuActive('/game-history') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/game-history',
      },
      {
        key: 3,
        label: `${t('sidebar.limit')}`,
        icon: <SidebarIcon.MaxBetLimitSetting color={isMenuActive('/limit') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/limit',
      },
      {
        key: 4,
        label: `${t('sidebar.payout_limit')}`,
        icon: <SidebarIcon.PayoutLimitSetting color={isMenuActive('/payout-limit') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/payout-limit',
      },
      {
        key: 5,
        label: `${t('sidebar.statistic.title')}`,
        icon: (
          <SidebarIcon.Report
            color={
              isParentMenuActive([
                { path: '/statistic/agent-point' },
                { path: '/statistic/point-by-vendor' },
                { path: '/statistic/daily' },
                { path: '/statistic/game-point' },
              ])
                ? '#FFFFFF'
                : '#9DA4AE'
            }
          />
        ),
        children: [
          {
            key: 5.1,
            label: `${t('sidebar.statistic.agent-point')}`,
            path: '/statistic/agent-point',
          },
          {
            key: 5.2,
            label: `${t('sidebar.statistic.point-vendor')}`,
            path: '/statistic/point-by-vendor',
          },
          {
            key: 5.3,
            label: `${t('sidebar.statistic.daily')}`,
            path: '/statistic/daily',
          },
          {
            key: 5.4,
            label: `${t('sidebar.statistic.table-point')}`,
            path: '/statistic/game-point',
          },
        ],
      },
      {
        key: 7,
        label: `${t('sidebar.provider')}`,
        icon: <SidebarIcon.VendorList color={isMenuActive('/provider') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/provider',
      },
      {
        key: 8,
        label: `${t('sidebar.game_list')}`,
        icon: <SidebarIcon.GameList color={isMenuActive('/game-list') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/game-list',
      },
      {
        key: 6,
        label: `${t('sidebar.user.title')}`,
        icon: (
          <SidebarIcon.UserManagement
            color={
              isParentMenuActive([{ path: '/users/list' }, { path: '/users/transactions' }]) ? '#FFFFFF' : '#9DA4AE'
            }
          />
        ),
        children: [
          {
            key: 6.1,
            label: `${t('sidebar.user.list')}`,
            path: '/users/list',
          },
          {
            key: 6.2,
            label: `${t('sidebar.user.transactions')}`,
            path: '/users/transactions',
          },
        ],
      },
      // {
      //   key: 9,
      //   label: `${t('sidebar.api_document')}`,
      //   icon: <SidebarIcon.ApiCent4er color={isMenuActive('/swagger') ? '#FFFFFF' : '#9DA4AE'} />,
      //   path: '/swagger',
      // },
      {
        key: 10,
        label: `${t('sidebar.setting')}`,
        icon: <SidebarIcon.Setting color={isMenuActive('/setting') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/setting',
      },
      {
        key: 11,
        label: `${t('sidebar.dashboard')}`,
        icon: <SidebarIcon.Dashboard color={isMenuActive('/dashboard') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/dashboard',
      },
      {
        key: 12,
        label: `${t('sidebar.vendor')}`,
        icon: <SidebarIcon.VendorList color={isMenuActive('/vendors') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/vendors',
      },
      {
        key: 13,
        label: `${t('sidebar.notice')}`,
        icon: <SidebarIcon.Notifications color={isMenuActive('/notifications') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/notifications',
      },
      {
        key: 14,
        label: `${t('sidebar.announcement')}`,
        icon: <SidebarIcon.Announcement color={isMenuActive('/announcements') ? '#FFFFFF' : '#9DA4AE'} />,
        path: '/announcements',
      },
    ],
    [location.pathname, t],
  );

  React.useEffect(() => {
    let activeParentKey: number | null = null;
    navs.forEach((item) => {
      if (item.children) {
        const hasActiveChild = item.children.some((child: any) => location.pathname === child.path);
        if (hasActiveChild) {
          activeParentKey = item.key;
        }
      }
    });

    if (activeParentKey !== null) {
      setIsSelected((prevSelected) => {
        const closedState = prevSelected.map((e) => ({
          ...e,
          value: false,
        }));

        const existingIndex = closedState.findIndex((e) => e.name === activeParentKey);
        if (existingIndex >= 0) {
          closedState[existingIndex] = { ...closedState[existingIndex], value: true };
        } else {
          closedState.push({ name: activeParentKey as number, value: true });
        }

        return closedState;
      });
    }

    if (!data) return;
    if (location.pathname === '/dashboard') return;

    if (!data.includes(location.pathname)) {
      navigate('/dashboard', { replace: true });
    }
  }, [location.pathname, navs, data]);

  return (
    <MenuWrapper sx={{ padding: isCollapsed ? '0' : '0 10px' }}>
      {navs
        .filter((x) => x.children || data?.includes(x.path))
        .map((item) => {
          if (item.children) {
            const child = [...item.children].filter((x) => data?.includes(x.path));
            if (child.length <= 0) return null;

            if (isCollapsed) {
              const firstChildPath = child[0]?.path;

              return (
                <SubMenuWrapper key={item.key}>
                  <List component="div">
                    <ListItem component="div">
                      <Tooltip title={item.label} placement="right" arrow>
                        <Button
                          disableRipple
                          component={RouterLink}
                          onClick={closeSidebar}
                          to={firstChildPath}
                          startIcon={item.icon}
                          sx={{
                            minWidth: 'auto',
                            justifyContent: 'center',
                            '& .MuiButton-startIcon': {
                              margin: 0,
                            },
                            '& svg path': {
                              transition: 'fill 0.3s ease, stroke 0.3s ease',
                            },
                            '&:hover svg path[fill="#9DA4AE"]': {
                              fill: '#FFFFFF !important',
                            },
                            '&:hover svg path[stroke="#9DA4AE"]': {
                              stroke: '#FFFFFF !important',
                            },
                          }}></Button>
                      </Tooltip>
                    </ListItem>
                  </List>
                </SubMenuWrapper>
              );
            }

            const hasActiveChild = child.some((x) => location.pathname === x.path);

            const activeIcon = React.cloneElement(item.icon as React.ReactElement, {
              color: hasActiveChild ? '#FFFFFF' : '#9DA4AE',
            });

            return (
              <List
                key={item.key}
                component="div"
                subheader={
                  <ListSubheader
                    component="div"
                    disableSticky
                    sx={{
                      padding: '7.2px 22px !important',
                    }}>
                    <MenuTile
                      onClick={() => {
                        const existingIndex = isSelected.findIndex((e) => e.name === item.key);
                        const isCurrentlyOpen = existingIndex >= 0 && isSelected[existingIndex].value;

                        if (isCurrentlyOpen) {
                          const newState = [...isSelected];
                          newState[existingIndex] = {
                            ...newState[existingIndex],
                            value: false,
                          };
                          setIsSelected(newState);
                        } else {
                          const newState = isSelected.map((e) => ({
                            ...e,
                            value: false,
                          }));

                          if (existingIndex >= 0) {
                            newState[existingIndex] = {
                              ...newState[existingIndex],
                              value: true,
                            };
                          } else {
                            newState.push({ name: item.key, value: true });
                          }

                          setIsSelected(newState);
                        }
                      }}
                      sx={{
                        '& svg path': {
                          transition: 'fill 0.3s ease, stroke 0.3s ease',
                        },
                        '&:hover svg path[fill="#9DA4AE"]': {
                          fill: '#FFFFFF !important',
                        },
                        '&:hover svg path[stroke="#9DA4AE"]': {
                          stroke: '#FFFFFF !important',
                        },
                        fontSize: '15px !important',
                        display: 'flex',
                        alignItems: 'center',
                      }}>
                      {activeIcon}
                      <TextTile
                        sx={{
                          color: hasActiveChild ? '#FFFFFF' : undefined,
                        }}>
                        {item.label}
                      </TextTile>
                      {isSelected.some((e) => e.name === item.key && e.value === true) ? (
                        <ExpandLess
                          sx={{
                            position: 'absolute',
                            right: '5px',
                            color: hasActiveChild ? '#FFFFFF' : undefined,
                          }}
                        />
                      ) : (
                        <ExpandMore
                          sx={{
                            position: 'absolute',
                            right: '5px',
                            color: hasActiveChild ? '#FFFFFF' : undefined,
                          }}
                        />
                      )}
                    </MenuTile>
                  </ListSubheader>
                }>
                <Collapse
                  in={isSelected.some((e) => e.name === item.key && e.value === true)}
                  timeout="auto"
                  unmountOnExit>
                  <SubMenuWrapper
                    sx={{
                      paddingLeft: '25px',
                    }}>
                    <List component="div">
                      {child.map((x) => {
                        const isChildActive = location.pathname === x.path;
                        return (
                          <ListItem key={`child-${x.key?.toString()}`} component="div">
                            <Button
                              disableRipple
                              component={RouterLink}
                              onClick={closeSidebar}
                              to={x.path}
                              sx={{
                                fontSize: '15px !important',
                                fontWeight: '400 !important',
                                color: isChildActive ? '#FFFFFF' : undefined,
                              }}>
                              {isChildActive ? (
                                <TextTile
                                  sx={{
                                    position: 'absolute',
                                    left: '0',
                                    marginTop: '0',
                                    fontSize: '25px',
                                    color: '#014CFF',
                                  }}>
                                  {`•`}
                                </TextTile>
                              ) : null}
                              {x.label}
                            </Button>
                          </ListItem>
                        );
                      })}
                    </List>
                  </SubMenuWrapper>
                </Collapse>
              </List>
            );
          }

          if (isCollapsed) {
            return (
              <SubMenuWrapper key={item.key}>
                <List component="div">
                  <ListItem component="div">
                    <Tooltip title={item.label} placement="right" arrow>
                      <Button
                        disableRipple
                        component={RouterLink}
                        onClick={closeSidebar}
                        to={item.path}
                        startIcon={item.icon}
                        sx={{
                          minWidth: 'auto',
                          justifyContent: 'center',
                          '& .MuiButton-startIcon': {
                            margin: 0,
                          },
                          '& svg path': {
                            transition: 'fill 0.3s ease, stroke 0.3s ease',
                          },
                          '&:hover svg path[fill="#9DA4AE"]': {
                            fill: '#FFFFFF !important',
                          },
                          '&:hover svg path[stroke="#9DA4AE"]': {
                            stroke: '#FFFFFF !important',
                          },
                        }}></Button>
                    </Tooltip>
                  </ListItem>
                </List>
              </SubMenuWrapper>
            );
          }

          return (
            <SubMenuWrapper key={item.key}>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to={item.path}
                    startIcon={item.icon}
                    sx={{
                      '& svg path': {
                        transition: 'fill 0.3s ease, stroke 0.3s ease',
                      },
                      '&:hover svg path[fill="#9DA4AE"]': {
                        fill: '#FFFFFF !important',
                      },
                      '&:hover svg path[stroke="#9DA4AE"]': {
                        stroke: '#FFFFFF !important',
                      },
                      fontSize: '15px !important',
                      display: 'flex',
                      alignItems: 'center',
                    }}>
                    {item.label}
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          );
        })}
    </MenuWrapper>
  );
}

export default React.memo(SidebarMenu);
